import React, {useCallback, useEffect, useState} from 'react';
import {byOptionsMode} from "../../../Graphs/constants";
import localStrings from "../../../localStrings";
import {filterOrderItemsWithProduct, getAllProductRefs, iterateSumUpDayProducts} from "../../../Graphs/BarGraphUtils";
import PieTurnover from "../../../Graphs/PieTurnover";
import {Tab, Tabs} from "@mui/material";
import cloneDeep from "clone-deep";
import {NoData} from "../../../Graphs/noData";
import useAuth from "../../../hooks/useAuth";
import {filterSingleDay} from "../../Home/FilterInfoOverview";

function OptionListsDetail({mapOptionOptionList, product}) {
    const [currentTab, setCurrentTab] = useState();
    const [orderFiltered, setOrderFiltered] = useState(null);
    const [mergedSumUpDayProductsFiltered, setMergedSumUpDayProductsFiltered] = useState(null);
    const [distinctOptionLists, setDistinctOptionLists] = useState(null);
    const [ordersFiltered, setOrdersFiltered] = useState(null);
    const handleTabsChange = (event, value) => {
        setCurrentTab(value);
    };

    const {orders, sumUpDays, mergedSumUpDay, filter} = useAuth();

    useEffect(() => {
        const filtered = orders.map(order => filterOrderItemsWithProduct(order, product)).filter(order => order != null);
        setOrderFiltered(filtered)
    }, [orders, product])

    useEffect(() => {
        if (!mergedSumUpDay || !currentTab) {
            return;
        }
        const allProductRefs = getAllProductRefs(product);
        let allProducts = []
        iterateSumUpDayProducts(mergedSumUpDay, ((productRef, productIter) => {
            var clonedProduct = cloneDeep(productIter);

            if (productRef !== product.ref && !allProductRefs.includes(productRef)) {
                return;
            }
            const keysOption = Object.keys(clonedProduct.options);
            keysOption.forEach(option => {
                if (mapOptionOptionList[option].optionListName !== currentTab) {
                    delete clonedProduct.options[option]
                }
            })
            allProducts.push(clonedProduct)

        }));



        setMergedSumUpDayProductsFiltered(allProducts)

    }, [mergedSumUpDay, product, currentTab])


    useEffect(() => {
        if (!currentTab) {
            return;
        }
        let filtered = cloneDeep(orders)
        filtered.forEach(order => {
            order.items.forEach(item => {
                item.options = item.options.filter(option => {
                    return mapOptionOptionList[option.ref]?.optionListName === currentTab
                })
            })})

        setOrdersFiltered(filtered)
    },[currentTab])

    useEffect(() => {
        const allOptions = [];

        if (orderFiltered && filter?.filterType === filterSingleDay) {
            orderFiltered.forEach(order => {
                order.items.forEach(item => {
                    item.options.forEach(option => {
                        if (!allOptions.includes(mapOptionOptionList[option.ref].optionListName)) {
                            allOptions.push(mapOptionOptionList[option.ref].optionListName)
                        }
                    })
                })
            })
            if (allOptions.length > 0 && !currentTab) {
                setCurrentTab(allOptions[0])
            }
            setDistinctOptionLists(allOptions)
        }
        else if (mergedSumUpDay) {
            let total = 0;
            const allProductRefs = getAllProductRefs(product);
            iterateSumUpDayProducts(mergedSumUpDay, ((productRef, productIter) => {


                if (!allProductRefs.includes(productRef) && productRef !== product.ref) {
                    return;
                }
                total += productIter.quantity;
                const keysOption = Object.keys(productIter.options);
                keysOption.forEach(option => {
                    if (mapOptionOptionList[option] && !allOptions.includes(mapOptionOptionList[option].optionListName)) {
                        allOptions.push(mapOptionOptionList[option].optionListName)
                    }
                })
            }));


            if (allOptions.length > 0 && !currentTab) {
                setCurrentTab(allOptions[0])
            }

            setDistinctOptionLists(allOptions)
        }
    }, [orderFiltered, mergedSumUpDay])

    const getTransformer = useCallback(() => {
        return order => {
            const filteredOrderItemsWithProduct = filterOrderItemsWithProduct(order, product);
            if (filteredOrderItemsWithProduct === null) {
                return null;
            }

            return filteredOrderItemsWithProduct
        };
    }, [currentTab]);


    return (
        <div>

            {/*<p>{JSON.stringify(orderFiltered || {})}</p>*/}
            {/*<p>{JSON.stringify(mergedSumUpDayProductsFiltered || {})}</p>*/}
            {distinctOptionLists && distinctOptionLists.length > 0 ?
                <Tabs
                    style={{marginLeft: '15px'}}
                    onChange={handleTabsChange}
                    scrollButtons="auto"
                    value={currentTab}
                    textColor="secondary"
                    variant="scrollable"
                >
                    {(distinctOptionLists || []).map( (optionList, key) =>
                        <Tab key={key} label={optionList} value={optionList} />
                    )}
                </Tabs>
                :
                <NoData/>
            }

            {currentTab  && (ordersFiltered || mergedSumUpDay) &&
                <PieTurnover
                    ordersData={ordersFiltered}
                    mergedSumUpDayProductsFiltered={mergedSumUpDayProductsFiltered}
                    unity=" "
                    displayMode={byOptionsMode}
                    title={currentTab}
                    product={product}
                    mapOptionOptionList={mapOptionOptionList}
                    transformer={getTransformer()}
                />
            }
        </div>
    )
}

export default OptionListsDetail